import { useEffect, useState } from 'react';

/**
 * `active`, but only once it has stayed true for `delayMs`, and false again the moment it ends.
 * A response that lands inside the delay never flips it, so a fast refresh shows no spinner.
 */
export function useDelayedFlag(active: boolean, delayMs: number) {
  const [isDelayedActive, setIsDelayedActive] = useState(false);

  useEffect(() => {
    if (!active) {
      setIsDelayedActive(false);

      return;
    }

    const timer = setTimeout(() => setIsDelayedActive(true), delayMs);

    return () => clearTimeout(timer);
  }, [active, delayMs]);

  return active && isDelayedActive;
}
